// Analytics init + automatic router-driven page tracking. No-ops when the
// Mixpanel token is unset (dev/CI).

import type { Router } from 'vue-router'
import { analytics } from '@core/monitoring'

export const initAnalytics = (router: Router): void => {
  analytics.init()
  router.afterEach((to) => {
    analytics.page(to.name?.toString() ?? to.path, { path: to.path })
  })
}
